/* eslint-disable no-nested-ternary */
import {
  Button,
  CircularProgress,
  IconButton,
  Input,
  InputLabel,
  Paper,
  Typography,
  makeStyles,
} from '@material-ui/core';
import Popup from 'reactjs-popup';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import React, { useState, useEffect } from 'react';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import VisibilityIcon from '@material-ui/icons/Visibility';
import moment from 'moment';
import Dropzone from 'react-dropzone';
import swal from 'sweetalert';
import FeatureFlagEmptyState from '../../../Components/FeatureFlagEmptyState';
import { mappedCurrentActiveRole } from '../../../../utils/roleMapping';
import {
  deleteTransactionsFileHandler,
  fileUploaderNew,
  getTransactionsSignedURL,
  getTransactionsViewURL,
} from '../../../../utils/fileUploadHandler';
import { isAlphaNumeric } from '../../../../utils/regexValidator';
import apiCaller from '../../../../utils/apiCallerOutstanding';
import myFirebase from '../../../../config/config';

const contentStyle = { width: '300px' };
const useStyles = makeStyles(theme => ({
  paper: { padding: '10px 20px', marginTop: 20 },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: '2px dashed lightgray',
    borderRadius: '5px',
    margin: '14px 20px',
  },
  viewButton: {
    background: '#52BE56',
    color: 'white',
    padding: '5px 15px 5px 15px',
  },
  viewCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  viewCardMeta: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  deleteModalButton: {
    width: '45%',
    background: '#52BE56',
    borderRadius: 0,
    color: 'white',
    margin: '5px',
  },
  cancelButton: {
    width: '45%',
    background: 'lightgray',
    borderRadius: 0,
    margin: '5px',
  },
  lrNumberContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  submitButton: {
    background: '#3366FF',
    color: 'white',
    fontSize: '12px',
    textTransform: 'capitalize',
  },
  lrNumber: {
    margin: '0px',
    fontWeight: '400',
    fontSize: '16px',
  },
  rejectRemarks: {
    color: 'red',
    textAlign: 'left',
    fontSize: '12px',
  },
}));

const inlineCheckIconStyle = {
  marginLeft: '10px',
  color: '#52BE56',
};
const LrUpload = ({
  currentTransactionData,
  activeRole,
  stylesClass,
  featureFlagFiles,
}) => {
  const classes = useStyles();
  const [uploading, setUploading] = useState(false);
  const [uploadedURL, setUploadedUrl] = useState('');
  const [fileDetails, setFileDetails] = useState({});
  const [lrNumber, setLrNumber] = useState('');
  const [lrFile, setLrFile] = useState(null);
  const [updatingLrNum, setUpdatingLrNum] = useState(false);

  const [isDeleting, setIsDeleting] = React.useState(false);
  const { transactionId } = currentTransactionData;

  const fetchLrUrl = async () => {
    setUploading(true);
    const body = {
      role: mappedCurrentActiveRole(activeRole),
      file_type: 'trip_lr',
      transaction_id: transactionId,
    };

    try {
      const response = await getTransactionsViewURL(body);
      setUploadedUrl(response?.data?.file_details?.url ?? '');
      setFileDetails(response?.data?.file_details);
      setUploading(false);
      if (response?.data?.file_details?.status === 'rejected') {
        setLrNumber(response?.data?.file_details?.doc_reference_number);
      }
    } catch (e) {
      setUploading(false);
      return null;
    }
  };

  const fetchS3URl = UploadedFile => {
    const body = {
      role: mappedCurrentActiveRole(activeRole),
      file_type: 'trip_lr',
      transaction_id: transactionId,
      doc_reference_number: lrNumber,
    };
    getTransactionsSignedURL(body, UploadedFile)
      .then(response => {
        const { url: signedURL, metadata } = response?.data;
        fileUploaderNew(signedURL, metadata, UploadedFile)
          .then(res => {
            if (res === 'success') {
              setTimeout(() => {
                fetchLrUrl();
                setUploading(false);
                setLrNumber('');
                setLrFile(null);
              }, 5000);
            }
          })
          .catch(e => {
            setUploading(false);
            return null;
          });
      })
      .catch(e => {
        setUploading(false);
      });
  };

  const onDrop = async acceptedFiles => {
    setUploading(true);
    fetchS3URl(acceptedFiles);
  };

  function viewFIleUploaded(podUrl) {
    window.open(podUrl);
  }

  async function deleteFIleUploaded() {
    setIsDeleting(true);
    const body = {
      role: mappedCurrentActiveRole(activeRole),
      file_type: 'trip_lr',
      transaction_id: transactionId,
    };
    try {
      await deleteTransactionsFileHandler(body);
      setUploadedUrl('');
      fetchLrUrl();
      setIsDeleting(false);
    } catch (e) {
      setIsDeleting(false);
    }
  }

  const viewFile = file => {
    if (!file) return;
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  };

  const handleLrNumberUpdate = async () => {
    const currentUserDetails = myFirebase.auth().currentUser;
    const { Aa } = currentUserDetails;
    const token = Aa;
    setUpdatingLrNum(true);

    const endPoint = 'trips/v1/lr-eway-number';
    const body = {
      role: mappedCurrentActiveRole(activeRole),
      transaction_id: transactionId,
      doc_type: 'trip_lr',
      doc_number: lrNumber,
    };
    try {
      await apiCaller(endPoint, body, `Bearer ${token}`, 'nh-base', 'post');
      swal({
        title: 'Success!',
        text: `LR Number Updated Successfully`,
        icon: 'success',
        timer: 3000,
      });
      fetchLrUrl();
      setLrNumber('');
      setUpdatingLrNum(false);
    } catch (e) {
      setUpdatingLrNum(false);
      swal({
        title: 'Error!',
        text: `Error While Updating LR Number, Please Try Again!`,
        icon: 'error',
      });
    }
  };

  useEffect(() => {
    setLrNumber('');
    fetchLrUrl();
  }, [activeRole, transactionId]);

  return (
    <>
      {currentTransactionData?.checkOne && currentTransactionData?.checkTwo ? (
        <Paper className={classes.paper}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h3
              className={`${stylesClass.classes.cardTitle} ${stylesClass.classes.rajdhaniFont}`}
              style={{ fontSize: '24px', textAlign: 'left' }}
            >
              LR
            </h3>
            {fileDetails?.status === 'approved' && (
              <CheckCircleIcon style={inlineCheckIconStyle} />
            )}
            {(fileDetails?.status === 'pending' ||
              fileDetails?.status === 'rejected') && (
              <p
                style={{
                  color:
                    fileDetails?.status === 'pending' ? '#363636' : 'white',
                  backgroundColor:
                    fileDetails?.status === 'pending' ? '#F1F2F4' : 'red',
                  padding: '5px',
                  borderRadius: '8px',
                  margin: '0px 0px 0px 5px',
                }}
              >
                {fileDetails?.status}
              </p>
            )}
          </div>
          <div className={classes.lrNumberContainer}>
            <InputLabel>Transporter Ref No(LR, THC etc):</InputLabel>
            {(activeRole === 'branch-ops' ||
              activeRole === 'sales' ||
              activeRole === 'traffic') &&
            (!fileDetails?.doc_reference_number ||
              fileDetails?.status === 'rejected') ? (
              <Input
                value={lrNumber}
                disabled={uploading}
                onChange={e => {
                  if (
                    isAlphaNumeric(e.target.value) &&
                    e.target.value.length <= 50
                  ) {
                    setLrNumber(e.target.value);
                  }
                }}
              />
            ) : (
              <h5 className={classes.lrNumber}>
                {fileDetails?.doc_reference_number || '–'}
              </h5>
            )}
            {(activeRole === 'branch-ops' ||
              activeRole === 'sales' ||
              activeRole === 'traffic') &&
              lrNumber &&
              fileDetails?.status === 'approved' &&
              !fileDetails?.doc_reference_number && (
                <Button
                  className={classes.submitButton}
                  size="small"
                  variant="contained"
                  color="primary"
                  disabled={!lrNumber || updatingLrNum}
                  onClick={() => handleLrNumberUpdate()}
                >
                  Save {updatingLrNum && <CircularProgress size={8} />}
                </Button>
              )}
          </div>
          {featureFlagFiles === 0 || featureFlagFiles === 2 ? (
            <>
              {uploadedURL === '' ? (
                <div>
                  {activeRole === 'sales' ||
                  activeRole === 'branch-ops' ||
                  activeRole === 'traffic' ? (
                    <div>
                      {lrFile ? (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: '10px',
                          }}
                        >
                          <div>
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => viewFile(lrFile)}
                              className={classes.viewButton}
                              disabled={uploading}
                            >
                              View
                            </Button>
                            <IconButton
                              color="primary"
                              component="span"
                              size="small"
                              onClick={() => setLrFile(null)}
                              disabled={uploading}
                            >
                              <DeleteOutlineIcon color="error" />
                            </IconButton>
                          </div>
                          <Button
                            size="small"
                            variant="contained"
                            className={classes.submitButton}
                            disabled={!lrNumber || !lrFile || uploading}
                            onClick={() => onDrop(lrFile)}
                          >
                            Submit {uploading && <CircularProgress size={10} />}
                          </Button>
                        </div>
                      ) : (
                        <Dropzone
                          accept="image/png,image/jpeg,application/pdf"
                          maxFiles={1}
                          onDrop={acceptedFiles => {
                            if (!acceptedFiles.length) return;
                            setLrFile(acceptedFiles[0]);
                          }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div
                              {...getRootProps()}
                              className={classes.container}
                            >
                              <input {...getInputProps()} />
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  flexDirection: 'column',
                                  marginTop: 5,
                                }}
                              >
                                {uploading ? (
                                  <CircularProgress />
                                ) : (
                                  <>
                                    <CloudUploadIcon />
                                    <p
                                      style={{
                                        fontSize: '10px',
                                        color: 'gray',
                                      }}
                                    >
                                      Drag and Drop or Click here to upload
                                    </p>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                        </Dropzone>
                      )}
                    </div>
                  ) : (
                    <div className={classes.viewCard} style={{ margin: '0px' }}>
                      <p>No file uploaded</p>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <div className={classes.viewCard}>
                    <div className={classes.viewCardMeta}>
                      <p style={{ fontWeight: 'bold', margin: '0px' }}>
                        {fileDetails?.uploaded_by ?? ''}
                      </p>
                      <p style={{ color: '#a9a9a9', fontSize: '12px' }}>
                        {moment(fileDetails?.updated_at).format('LLL')}
                      </p>
                    </div>
                    <div>
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        className={classes.viewButton}
                        onClick={() => viewFIleUploaded(uploadedURL)}
                        startIcon={<VisibilityIcon />}
                      >
                        View
                      </Button>
                      {activeRole === 'ops' && (
                        <Popup
                          trigger={
                            isDeleting ? (
                              <CircularProgress
                                style={{ color: '#FCD21F', margin: '5px' }}
                                size={30}
                                thickness={8}
                              />
                            ) : (
                              <IconButton
                                color="primary"
                                aria-label="upload picture"
                                component="span"
                                disabled={fileDetails?.status !== 'approved'}
                              >
                                <DeleteOutlineIcon
                                  color={
                                    fileDetails?.status !== 'approved'
                                      ? ''
                                      : 'error'
                                  }
                                />
                              </IconButton>
                            )
                          }
                          {...{
                            contentStyle,
                          }}
                          modal
                        >
                          {close => (
                            <div
                              style={{
                                padding: '10px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <HighlightOffIcon
                                fontSize="large"
                                color="error"
                              />

                              <h4 style={{ fontWeight: 'bold' }}>
                                Are You Sure?
                              </h4>
                              <p>
                                If you proceed, you will not be able to recover
                                it
                              </p>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  width: '100%',
                                }}
                              >
                                <Button
                                  onClick={close}
                                  className={classes.cancelButton}
                                >
                                  No
                                </Button>

                                <Button
                                  onClick={() => {
                                    close();
                                    deleteFIleUploaded();
                                  }}
                                  className={classes.deleteModalButton}
                                >
                                  Yes
                                </Button>
                              </div>
                            </div>
                          )}
                        </Popup>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : featureFlagFiles === 1 ? (
            <FeatureFlagEmptyState color="black" />
          ) : null}
          {fileDetails?.rejection_remarks &&
            fileDetails?.status === 'rejected' &&
            !lrFile && (
              <Typography className={classes.rejectRemarks}>
                Reject Remarks: {fileDetails?.rejection_remarks}
              </Typography>
            )}
        </Paper>
      ) : null}
    </>
  );
};

export default LrUpload;
